import Http from "../http";

// SAM-257: the writes below return `{ success: false, data: null }` on failure.
// They used to return `[]` (truthy), so a caller that ignored the result — or
// checked `if (result)` — could not tell a rejection from a completed write.
// The v2 controller replies `{ success, data }` on both paths, so the failure
// value now matches the shape callers already destructure. Reads keep `[]`:
// for a list render an empty list is the intended degraded state.

export const getSkillsList = async (params) => {
  const path = `/v2/skills`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: params,
    });
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getSkill = async (skillId) => {
  const path = `/v2/skills/${skillId}`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const createSkill = async (params) => {
  const path = `/v2/skills`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const updateSkill = async (params) => {
  const path = `/v2/skills/${params._id}`;
  try {
    const response = await Http.sharedInstance.withAuth().patch(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const deleteSkill = async (params) => {
  const path = `/v2/skills/${params._id}`;
  try {
    const response = await Http.sharedInstance.withAuth().delete(path);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const assignSkillsToUser = async (params, userId) => {
  const path = `/v2/skills/user/${userId}`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const removeSkillsFromUser = async (params, userId) => {
  const path = `/v2/skills/user/${userId}/${params.skills[0]}`;
  try {
    const response = await Http.sharedInstance.withAuth().delete(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const assignSkillsToJob = async (params, jobId) => {
  const path = `/v2/skills/job/${jobId}`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const assignSkillsToJobType = async (params, jobTypeId) => {
  const path = `/v2/skills/jobType/${jobTypeId}`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const updateSkillExpiration = async ({
  skillId,
  userId,
  expiration,
}) => {
  const path = `/v2/skills/${skillId}/expiration/${userId}`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, {
      expiration,
    });
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};
